import { compose } from 'recompose';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Link } from '@lifeomic/chroma-react/components/Link';
import urls from '../../util/urls';
import {
  Alert,
  AlertBody,
  AlertIcon,
} from '@lifeomic/chroma-react/components/Alert';
import { Info } from '@lifeomic/chromicons';

class AccountPermissionsDisclaimer extends React.PureComponent {
  render() {
    return (
      <Alert statusType="info" fullWidth>
        <AlertIcon icon={Info} />
        <AlertBody>
          <Text size="subbody">
            <FormattedMessage
              id="accountPermissionsDisclaimer.text"
              defaultMessage="Don't see the account options you're looking for? {permissions} or contact your administrator."
              values={{
                permissions: (
                  <Link to={urls.app.userProfile()}>
                    <b>View permissions</b>
                  </Link>
                ),
              }}
            />
          </Text>
        </AlertBody>
      </Alert>
    );
  }
}

export default compose(withRouter, injectIntl)(AccountPermissionsDisclaimer);
